export const setParamsInPath = (path, params) => (
	// TODO: handle paths like CABINET, with optional params
	Object.keys(params).reduce((acc, paramName) => (
		acc.replace(`:${paramName}`, params[paramName])
	), path)
)
